import { useTranslation } from 'react-i18next';
import { useLabel } from '@platform/hooks/useLabel';
import { cx } from '@platform/core/lib/cx';
import type { IOnboardModulesProps } from './IOnboardModulesProps';
import { onboardCount } from './onboardGroups';

/**
 * «Модулі» сторінки створення простору (прототип v4): рядок «Справи, завдання й теги — основні сутності — завжди включені» з позначкою
 * «Включено», «N додаткових модулів вибрано» і групи за категоріями — плитки модулів сіткою minmax(170px) з описом у підказці; вибрана —
 * рамка акцентом. Плитки одного пакета перемикаються разом; обов'язкові пакети позначені й не перемикаються.
 */
export function OnboardModules({ groups, picked, onToggle }: IOnboardModulesProps) {
  const { t } = useTranslation();
  const label = useLabel();
  return (
    <div className="ob__mods">
      <div className="ob__eyebrow">{t('auth.onboard.modules')}</div>
      <div className="ob__core">
        <div className="ob__coretext"><div className="ob__corename">{t('auth.onboard.core')}</div><div className="ob__coresub">{t('auth.onboard.coreSub')}</div></div>
        <span className="ob__included">{t('auth.onboard.included')}</span>
      </div>
      <div className="ob__count">{t('auth.onboard.selected', { count: onboardCount(groups, picked) })}</div>
      {groups.map((g) => (
        <div key={g.category} className="ob__group">
          <div className="ob__cat">{label(g.label)}</div>
          <div className="ob__grid">
            {g.tiles.map((tile) => {
              const on = tile.required || !!picked[tile.module];
              const hint = tile.required ? `${label(tile.description)} · ${t('auth.onboard.alwaysIncluded')}` : label(tile.description);
              return (
                <label key={tile.key} className={cx('ob__mod', on && 'is-on', tile.required && 'is-locked')} title={hint}>
                  <input type="checkbox" checked={on} disabled={tile.required} onChange={() => onToggle(tile.module)} />
                  <span className="ob__modname">{label(tile.label)}</span>
                </label>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
